import i18n from "../i18n";
import { TranslateDescription } from "../types/TranslateDescription";

export const getLocalizedText = (text?: TranslateDescription): string => {
    if (!text) return "";

    const language = (i18n.language || "en").toLowerCase();

    if (language.startsWith("es")) return text.spanish || text.english || "";
    if (language.startsWith("ca")) return text.catalan || text.english || "";
    if (language.startsWith("fr")) return text.french || text.english || "";

    return text.english || "";
};